import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Icon } from '@evertrue/et-components';
import { connect } from '@evertrue/et-flux';
import LayoutStore from 'apps/layout/stores/layout-store';

/**
 * Expandable navigation item with nested sub-items.
 * Used for nav sections like Outreach Planner, Tasks, and Assets.
 */

const mapStateToProps = () => ({
  navIsCollapsed: LayoutStore.getNavState(),
});

const NavigationExpandableItem = ({
  icon,
  iconKit = 'gt',
  label,
  isActive = false,
  children,
  navIsCollapsed,
  badge,
  defaultExpanded = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="nav-expandable-item">
      <Button
        type="simple"
        accessibilityAttributes={{ role: 'button', tabIndex: '0', 'aria-expanded': isExpanded }}
        onClick={handleToggle}
        className={classNames('nav-expandable-item--header', {
          'is-active': isActive,
          'is-expanded': isExpanded,
        })}
      >
        {icon && <Icon className="base-nav-sub-item--icon" icon={icon} iconKit={iconKit} />}
        <span className="base-nav-sub-item--label">{label}</span>
        <span className="nav-expandable-item--badge">{badge}</span>
        {!navIsCollapsed && (
          <Icon
            className="nav-expandable-item--chevron"
            icon={isExpanded ? 'chevron-down' : 'chevron-right'}
            iconKit="gt"
          />
        )}
      </Button>
      {isExpanded && !navIsCollapsed && <div className="nav-expandable-item--children">{children}</div>}
    </div>
  );
};

NavigationExpandableItem.propTypes = {
  icon: PropTypes.string,
  iconKit: PropTypes.string,
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  children: PropTypes.node,
  navIsCollapsed: PropTypes.bool,
  badge: PropTypes.node,
  defaultExpanded: PropTypes.bool,
};

export default connect(NavigationExpandableItem, [LayoutStore], mapStateToProps);
